export const TOTAL_FUNDING_TEXT = {
	title: 'How much funding do you need?',
	subtitle: 'Please enter any amount between $50,000 and $20,000,000.',
};

export const FUNDING_PURPOSE_TEXT = {
	title: 'What is the purpose of the loan?',
	subtitle: 'Please select how you intend to use the loan funds.',
};

export const FICO_SCORE_TEXT = {
	title: 'What is your FICO® credit score?',
	subtitle: 'Please select the range that applies to you:',
};

export const FUNDS_ACCESS_TIME_TEXT = {
	title: 'What is your preferred timeline for accessing the funds?',
	subtitle: 'Choose one of the options provided:',
};

export const OWNER_INFO_TEXT = {
	title: 'Primary Contact Details',
	subtitle: 'Please provide contact details for the primary borrower for this loan.',
};

export const OWNER_INFO_BUY_BUSINESS_TEXT = {
	title: 'Primary Contact Details',
	subtitle: 'Please provide contact details for the primary borrower for this loan.',
};

export const BUSINESS_INFO_TEXT = {
	title: 'Business Information',
	subtitle:
		'Please provide additional details about the business entity that will serve as the loan borrower.',
};

export const ENTITY_AND_EIN_INFO_TEXT = {
	title: 'Entity and EIN Information',
	subtitle: 'Please provide these details about your business:',
};

export const BUSINESS_OWNERSHIP_TEXT = {
	title: 'Owner Information',
	subtitle: 'Please provide contact details for all of the business owners:',
};

export const BUSINESS_OWNERSHIP_SOLE_PROPRIETOR_TEXT = {
	...BUSINESS_OWNERSHIP_TEXT,
	subtitle: 'Please provide the contact details for the business owner:',
};

export const REQUIRED_FIELD_ERROR_MESSAGE = 'Please fill out this required field';
export const REQUIRED_FIELD_SHORT_ERROR_MESSAGE = 'This field is required';

//debts texts
export const DEBT_GET_STARTED_TEXT = {
	title: 'Please Tell Us About Your Business Debts',
	subtitle: "To proceed, we need information about your business's existing debts.",
};

export const DEBT_LENDER_TEXT = {
	title: 'Who is the lender for this debt?',
	subtitle:
		"If you don't recall the exact name, briefly describe the source (for example, 'bank loan,' 'private investor,' or 'credit card').",
};

export const DEBT_LOAN_DATE_TEXT = {
	title: 'What date (approximately) did you first receive the loan funds?',
	subtitle: 'An estimate is okay (example: January, 1, 2020)',
};

export const DEBT_LOAN_AMOUNT_TEXT = {
	title: 'What was the full amount of the loan when you received it?',
	subtitle: "Don't worry if you're not sure of the exact figure—approximate if needed.",
};

export const DEBT_LOAN_TERM_TEXT = {
	title: 'How many months were you originally given to pay this loan off (the term)?',
	subtitle: "If it's ongoing or no set term, leave blank or estimate.",
};

export const DEBT_INTEREST_RATE_TEXT = {
	title: "What's the annual interest rate (as a percentage) on this loan?",
	subtitle: 'Estimate if unsure—we just need a rough idea.',
};

export const DEBT_BALANCE_TEXT = {
	title: 'What is your best estimate of the outstanding balance right now?',
	subtitle: "If you're not certain, you can estimate.",
};

export const DEBT_ANNUAL_SCHEDULE_TEXT = {
	title: 'Do you have an annual payment schedule on this loan?',
	subtitle: 'If applicable, enter the amount per year.',
};

export const DEBT_SBA_LOAN_TEXT = {
	title: 'Is this an SBA (Small Business Administration) loan?',
	subtitle: 'If you’re unsure, just make your best guess.',
};

export const DEBT_REFINANCE_TEXT = {
	title: 'If given the option, would you like to refinance or consolidate this debt?',
	subtitle: 'This simply helps us understand your future financing plans.',
};

export const DEBT_ADD_ANOTHER_TEXT = {
	title: 'Would you like to add another loan or line of credit to your schedule?',
	subtitle: 'This simply helps us understand your future financing plans.',
};

export const DEBT_MONTHLY_PAYMENT_TEXT = {
	title: 'How much do you pay monthly?',
	subtitle: 'Enter the amount you pay to this creditor monthly (estimates are fine)',
};
